<template>
    <phoenix-wrapper>
        <div class="my-10">
          
            <div class="steps-title flex flex-col justify-around w-350 md:w-670 mx-auto">
                <h2 class="text-grey">Update Mode</h2>
                <br>
                <p class="text-grey mr-5">We need some information to reconnect with Plaid</p>
            </div>

            <div class="if-loading" v-if="verifying">
                <div class="inside-container-1 flex flex-col w-full sm:w-317 mx-auto">
                    <h2 class="text-center text-2xl md:text-4xl">Verifying Bank Account</h2>
                    <p class="text-center my-4">Please wait while we verify your bank account.</p>
                </div>

                <div class="flex flex-grow justify-center items-center">
                    <i class="fa fa-circle-notch fa-spin text-3xl" />
                </div>
            </div>

            <div aria-live="polite" role="status">
                <p v-if="showReconnectError" class="text-center text-red-500 my-4">
                    {{ reconnectErrorMessage }}
                </p>

                <p v-if="showSupportRoute" class="text-center text-grey my-4">
                    Still not working?
                    <a :href="supportHref" class="underline">Contact support</a>
                    and we'll reconnect your bank for you.
                </p>
            </div>

            <AppButton v-if="reconnectFailed" :loading="loading && !verifying" :disabled="verifying" @click="retryUpdateMode" class="w-full mt-5">Try Again</AppButton>
            <AppButton v-else :loading="loading && !verifying" :disabled="verifying" @click="handleUpdateMode" class="w-full mt-5">{{ failedAttempts > 0 ? 'Try Again' : 'Verify Bank Account' }}</AppButton>

        </div>
    </phoenix-wrapper>
</template>

<script>
import AppBoxContent from "./../../../components/AppBoxContent";
import AppButton from "./../../../components/AppButton";

export default {
    components: {
        AppBoxContent,
        AppButton
    },

    props: ['loan', 'user', 'link'],

    mixins: [require("./../../../mixins/PlaidUpdateModeMethod").default],

    data() {
        return {
            plaid: null,
            loading: false,
            verifying: false,
            reconnectFailed: false,
            failedAttempts: 0,
            failureKind: '',
        };
    },
    
};
</script>
